import React, { useEffect, useState } from "react";
import { Col, Image, Row, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useLocation } from "react-router-dom";
import moment from "moment";

const SuperAdminMainUserFavoritesGroupEvent = () => {
  const location = useLocation();

  const [eventData, setEventData] = useState();
  useEffect(() => {
    setEventData(location && location.state && location.state.data);
  }, [location]);

  const OfferImage = eventData && eventData.photos[0];
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="container-fluid">
              <Row>
                <Col lg={5}>
                  <Col className="pt-4 pb-3">
                    <NavLink
                      to="/superadminuserfavorite/group"
                      className="f12-500 enBackLink"
                    >
                      <Image
                        fluid
                        alt="Back Icon"
                        title="Back Icon"
                        className="mr-2"
                        src={require("../../../../assets/images/UserManagement/backIcon.svg")}
                      />
                      Back
                    </NavLink>
                    <div className="f24_700_HelveticaNeue">
                      Favourite- {eventData && eventData.name}
                    </div>
                    <div className="enRestaurantBox mt-3">
                      <div
                        className="enlogo"
                        style={{
                          backgroundImage:
                            "url(" +
                            OfferImage +
                            // require("../../../../assets/images/UserManagement/restaurent-img.png") +
                            ")",
                        }}
                      >
                        <div className="enRElogo">
                          <Image
                            //src={require("../../../../assets/images/superadmin/streetmeat.png")}
                            src={
                              eventData &&
                              eventData.restaurant_id &&
                              eventData.restaurant_id.logo_url
                            }
                            alt="Profile pic"
                            title="Profile Pic"
                            fluid
                          />
                        </div>
                      </div>
                      <div className="enContent">
                        <div className="d-flex align-items-center">
                          <div className="f14-700">
                            {eventData &&
                              eventData.restaurant_id &&
                              eventData.restaurant_id.restaurant_name}
                          </div>
                          {/* <div className="enSuccessLBL ml-2">ONLINE</div> */}
                          <div className="enPendingLBL ml-2">OFFLINE</div>
                        </div>
                        <div className="f11-400 text-gray mt-4">
                          {eventData && eventData.description}
                        </div>
                        <div className="d-flex flex-wrap mt-5">
                          <div className="d-flex align-items-start pr-3">
                            <Image
                              src={require("../../../../assets/images/UserManagement/calendar-red.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="17px"
                            />
                            <div className="pl-3">
                              <div className="f9-400 text-gray">Dates</div>
                              <div className="f13-500">
                                {moment(
                                  eventData && eventData.start_date
                                ).format("Do MMMM  YYYY")}
                              </div>
                              <div className="f13-500">
                                -{" "}
                                {moment(eventData && eventData.end_date).format(
                                  "Do MMMM  YYYY"
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-start pl-3">
                            <Image
                              src={require("../../../../assets/images/UserManagement/clock-red.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="17px"
                            />
                            <div className="pl-3">
                              <div className="f9-400 text-gray">Time</div>
                              <div className="f13-500">
                                {moment(
                                  eventData && eventData.start_date
                                ).format("LT")}{" "}
                                -
                              </div>
                              <div className="f13-500">
                                {moment(eventData && eventData.end_date).format(
                                  "LT"
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
                <Col lg={7} className="enBgGray enMinHeight100vh">
                  <div className="f14-500 opacity5 my-5">
                    Event ID- {eventData && eventData._id}
                  </div>
                  <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth500">
                      <thead>
                        <tr className="super_admin_all_users_table_head">
                          <th style={{ width: "30%" }}>User Name</th>
                          <th style={{ width: "20%" }}>Date -Time</th>
                          <th style={{ width: "36%" }}>Comments</th>
                          <th style={{ width: "14%" }}>Status</th>
                        </tr>
                      </thead>
                      {eventData &&
                        eventData.activityData &&
                        eventData.activityData.map((activity, index) => (
                          <tbody key={index}>
                            <tr className="enUserFavoritesTableBody">
                              <td style={{ width: "30%" }}>
                                <div className="d-flex align-items-center">
                                  <div className="restaurant_image_box_user">
                                    {activity &&
                                    activity.user_id &&
                                    activity.user_id.profile_photo[0] ? (
                                      <Image
                                        src={activity.user_id.profile_photo[0]}
                                        alt="Profile pic"
                                        title="Profile Pic"
                                        fluid
                                      />
                                    ) : (
                                      <Image
                                        src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                        alt="Profile pic"
                                        title="Profile Pic"
                                        fluid
                                      />
                                    )}
                                  </div>
                                  <div className="f12-500">
                                    {" "}
                                    {activity &&
                                      activity.user_id &&
                                      activity.user_id.first_name}{" "}
                                    {activity &&
                                      activity.user_id &&
                                      activity.user_id.last_name}{" "}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "20%" }}>
                                <div className="f14-500">
                                  {" "}
                                  {moment(
                                    activity && activity.createdAt
                                  ).format("DD-MM-YYYY")}
                                </div>
                                <div className="f14-500">
                                  {moment(
                                    activity && activity.createdAt
                                  ).format("LT")}
                                </div>
                              </td>
                              <td style={{ width: "36%" }}>
                                <div className="f14-500">
                                  {activity && activity.message}
                                </div>
                              </td>
                              <td style={{ width: "14%" }}>
                                <div className="f14-500">
                                  {" "}
                                  {activity && activity.status ? (
                                    <> On </>
                                  ) : (
                                    <> Off </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </Table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminMainUserFavoritesGroupEvent;
